import { Component, Input } from '@angular/core';
import { IconV3Component } from '@gea/digital-ui-lib';
import { ApiService } from 'src/app/shared/services/api.service';
import { User } from 'src/app/shared/data/data.generated';
import { TooltipModule } from 'primeng/tooltip';

@Component({
  selector: 'notifications-icons-renderer',
  template: `
    <span style="display: flex; gap: 1rem;">
      @if (rowData?.OrderStatusNotificationName) {
        <geaui-icon-v3
          [file]="'progress'"
          [fileSize]="16"
          [pTooltip]="'Order Status'"
        ></geaui-icon-v3>
      }
      @if (hasFeedbackNotification) {
        <geaui-icon-v3
          [file]="'b-comment'"
          [fileSize]="16"
          [appName]="'hrt/connect'"
          [pTooltip]="'Feedback'"
        ></geaui-icon-v3>
      }
    </span>
  `,
  standalone: true,
  imports: [TooltipModule, IconV3Component],
})
export class NotificationsIconsRenderer {
  constructor(private api: ApiService) {}
  @Input() rowData: any;

  hasFeedbackNotification: boolean = false;

  ngOnInit(): void {
    if (this.rowData?.Id) {
      this.api.Users.GetUserNotifications(this.rowData.Id).subscribe({
        next: (notifications) => {
          if (notifications && notifications.length > 0) {
            this.hasFeedbackNotification = true;
          } else {
            this.hasFeedbackNotification = false;
          }
        },
        error: () => {
          this.hasFeedbackNotification = false;
        },
      });
    }
  }
}
